require('normalize.css/normalize.css');
require('bootstrap/dist/css/bootstrap.min.css');
require('styles/App.less');

const axios = require('axios');

import React from 'react';
import Header from './Header';
import Footer from './Footer';
import AuthStore from '../stores/AuthStore';
import { withRouter } from 'react-router-dom';

class AppComponent extends React.Component {
  constructor(){
    super();
    this.state = {
      authenticated: AuthStore.isAuthenticated()
    }
  }

  componentWillMount() {
    const conf = window.ODOO
    if(document.querySelector('.logoStyle') === null){
      let logo = document.createElement('style')
      logo.classList.add('logoStyle');
      logo.innerHTML +=`
        header .logo{
          background-image: url(${conf.url + (conf.port?':'+conf.port:'')}/web/binary/company_logo)
        }
        `
      document.getElementsByTagName('head')[0].appendChild(logo);
    }
    if(document.querySelector('.brandStyle') === null){
      let brandUrl = conf.url + (conf.port?':'+conf.port:'')+'/brand/'
      axios.get(brandUrl).then(function (response) {
        if(response.status == 200){
          let brandData = response.data
          let style = document.createElement('style')
          style.classList.add('brandStyle');
          if (brandData && brandData.colors && brandData.colors['@brand-primary'] && brandData.colors['@brand-primary-text']){
            style.innerHTML = `
              #app thead tr,
              #app main button,
              #app main .button,
              #app main .task-kanban .task-column h3,
              #app main input[type="submit"],
              #app footer,
              #popupContainer .mm-popup__btn
              {
                background-color: ${brandData.colors['@brand-primary']};
                color: ${brandData.colors['@brand-primary-text']};
              }
              main .elem-list .elem-tile:hover,
              #popupContainer .mm-popup__btn{
                border-color: ${brandData.colors['@brand-primary']};
              }
              `
          }
          document.getElementsByTagName('head')[0].appendChild(style);
        }
      }).catch(function () {
        //no brand data - do nothing
      }).then(function(){
        document.querySelector('.loaderWrap').style.display = 'none'
      })
    }
  }

  render() {
    return (
      <article>
        <Header authenticated={this.props.authenticated}></Header>
        <main>
        {this.props.children}
        </main>
        <Footer />
      </article>
    )
  }

  componentDidMount(){
    //todo: sprawdzanie logowania
  }
}

AppComponent.defaultProps = {
};

export default withRouter(AppComponent);



// WEBPACK FOOTER //
// ./src/components/App.js